import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from 'src/components/ApplyTo/Company.scss';


const PictureSource = ({
  device, defaultImage, name, isSingle
}) => (
  <React.Fragment>
    <source
      media={ `(min-width: ${device.deviceWidth})` }
      srcSet={
        Object.entries(device.images).map(([, { url, density }]) => `${url} ${density}x`).join(', ')
      }
    />
    <img
      alt={ name }
      className={
        classNames({
          [styles['company-logo__img']]: true,
          [styles['company-logo__img--single']]: isSingle
        })
      }
      src={ defaultImage.url }
    />
  </React.Fragment>
);

PictureSource.propTypes = {
  defaultImage: PropTypes.shape({
    size: PropTypes.string,
    url: PropTypes.string
  }).isRequired,
  device: PropTypes.shape({
    deviceWidth: PropTypes.string,
    images: PropTypes.array
  }).isRequired,
  isSingle: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired
};

export default PictureSource;
